export const LAUNCHDARKLY_URL = 'app.launchdarkly.com';
export const LAUNCHDARKLY_EVENT_URL = 'events.launchdarkly.com';
